module.exports = __webpack_public_path__ + "static/media/lightPolygon.758818c9.svg";